
import React from 'react';
import { RefreshCw } from 'lucide-react';

export const UserTableLoading: React.FC = () => {
  return (
    <div className="flex justify-center items-center h-64">
      <div className="flex flex-col items-center">
        <RefreshCw className="h-8 w-8 animate-spin text-primary mb-2" />
        <p className="text-muted-foreground">Loading users...</p>
      </div>
    </div>
  );
};
